<template>
  <div>
    <header>
      <div class="header">
        <div>
          <dl class="logo">
            <dt>
              <a @click.stop="toPage('')"
                ><img
                  style="cursor: pointer"
                  src="../../assets/images/logo.png"
              /></a>
            </dt>
            <dd>
              <img src="../../assets/images/slogan.png" />
            </dd>
          </dl>
        </div>
        <div style="background: #3f68aa">
          <ul class="nav">
            <li>
              <a
                :class="pageName === 'home' ? 'page active' : 'page'"
                @click.stop="toPage('')"
                href="javascript:void 0;"
              >
                首页
              </a>
            </li>
            <li>
              <a
                :class="pageName === 'articlelist' ? 'page active' : 'page'"
                href="javascript:void 0;"
                @click.stop="toPage('articlelist')"
              >
                学术动态
              </a>
            </li>
            <!-- <li>
              <a
                :class="
                  ~['clinical', 'ClinincalList'].indexOf(pageName) && youth
                    ? 'page active'
                    : 'page'
                "
                href="javascript:void 0;"
                @click.stop="toPage('clinical', '1')"
              >
                青年核医说
              </a>
            </li> -->
            <li>
              <a
                :class="pageName === 'teachingvideo' ? 'page active' : 'page'"
                href="javascript:void 0;"
                @click.stop="toPage('teachingvideo')"
              >
                学术讲座
              </a>
            </li>
            <li
              @click.stop="toPage('sectionintroduction')"
              :class="
                ['sectionintroduction', 'expertelist'].indexOf(pageName) !== -1
                  ? 'page active'
                  : 'page'
              "
            >
              成员单位
            </li>
            <li>
              <a
                :class="
                  ~['clinical', 'ClinincalList'].indexOf(pageName) && !youth
                    ? 'page active'
                    : 'page'
                "
                href="javascript:void 0;"
                @click.stop="toPage('clinical')"
              >
                指南规范
              </a>
            </li>
            <li>
              <a
                :class="
                  ~['radiate', 'radiateList'].indexOf(pageName)
                    ? 'page active'
                    : 'page'
                "
                href="javascript:void 0;"
                @click.stop="toPage('radiate')"
              >
                辐射安全
              </a>
            </li>
            <li>
              <a
                :class="
                  ~['qc', 'qcList'].indexOf(pageName) ? 'page active' : 'page'
                "
                href="javascript:void 0;"
                @click.stop="toPage('qc')"
              >
                质量控制
              </a>
            </li>
            <li class="readWill">
              <a
                :class="
                  ~['qc', 'qcList'].indexOf(pageName) ? 'page active' : 'page'
                "
                href="javascript:void 0;"
                @click.stop="toPage('readWill')"
              >
                云上读片会
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      pageName: "home",
      youth: false,
    };
  },
  mounted() {
    const path = this.$route.path;
    this.pageName = path.split("/")[1];
    this.changeRoute();
  },
  methods: {
    changeRoute() {
      let query = this.$route.query;
      if (query.youth) {
        this.youth = true;
      } else {
        this.youth = false;
      }
    },
    toPage(src, youth) {
      if (src === "readWill") {
        return window.open("https://www.rayplus.net/homePage", "_blank");
      }
      const path = `/${src}`;
      const pageName = src === "" ? "home" : src;
      this.pageName = pageName;
      let query = {};
      if (youth) {
        query.youth = 1;
      }
      this.$router.push({ path: path, query });
    },
  },
  watch: {
    $route() {
      let path = this.$route.path;
      this.pageName = path.split("/")[1];
      window.scrollTo(0, 0);
    },
    "$route.fullPath"() {
      this.changeRoute();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./Header.scss";
</style>
